'use client';

import { useLiveTimer } from '@/features/odds-page/hooks/use-live-timer';
import { LiveTimer } from '@nf/types/live-timer';
import { MatchModelBase, SportMatchModel } from '@nf/types/odds';
import { RedCardTemplate } from './mtach-redcard-template';
import { VsScore } from './match-live-score';
import { useTranslations } from 'next-intl';

export const Vs = ({ match }: { match: MatchModelBase }) => {
	return (
		<div className="vs">
			{match?.IsLive ? <LiveScore match={match} /> : <NonliveScore match={match} />}
		</div>
	);
};

const LiveScore = ({ match }: { match: MatchModelBase }) => {
	const t = useTranslations('General');
	const liveTimer: LiveTimer = useLiveTimer(match);
	const isShowMatchStatus = liveTimer.matchStatus && !liveTimer.countdownDomRef;
	const isSlideContainer = liveTimer.event && (liveTimer.matchStatus || liveTimer.countdownDomRef);
	const CricketMatchStatus = (match: MatchModelBase) => {
		const { ShowTime, Tsp } = match;
		if (Tsp) {
			return t('lbl_Crckt_Stumps');
		} else if (ShowTime === 'Ref_htime') {
			return t('lbl_InnsBreak');
		} else {
			return t(ShowTime) || '';
		}
	};
	const EsportDisplayMap =() => {
		const CMP = match?.CMP;
		const MapName = (CMP && t(`lbl_map${CMP}`)) ? t(`lbl_map${CMP}`) :'Map '+ CMP;
		const isShowEsportMap = (match?.GameID === 43) && (match?.ISS === 0)
		
		return isShowEsportMap ? (
			<div className="vs__time">
				<span className="text-inplay" data-inplay="true">{MapName}</span>
			</div>
		) : null
	}
	

	return (
		match?.GameID === 50 ? (
			<>
				<div className="vs__time">{t('lbl_live')}</div>
				<div className="vs__status">
					{
						match.ShowTime && match.ShowTime !== 'Ref_live' || match.Tsp ?
							<div className="happen">
								{CricketMatchStatus(match)}
							</div> : null
					}
				</div>
			</>
		) : (
			<>
				{
					isShowMatchStatus ? (
						<>
							{EsportDisplayMap() || null}
							<div className="vs__time" >{liveTimer.matchStatus}</div>
						</>
					) : (
						<div className="vs__time" ref={liveTimer.countdownDomRef} />
					)
				}
				<VsScore match={match as SportMatchModel} />
				{
					<div className="vs__status">
						<RedCardTemplate redCardCount={match.Rc1} />
						<div className="vs__col-middle">
							{
								isSlideContainer ? <div className="happen">{t(liveTimer.event)}</div> : null
							}
						</div>
						<RedCardTemplate redCardCount={match.Rc2} />
					</div>
				}
			</>
		)
	);
};

const NonliveScore = ({ match }: { match: MatchModelBase }) => {
	const liveTimer: LiveTimer = useLiveTimer(match);
	return <div className="vs__time" dangerouslySetInnerHTML={{ __html: liveTimer.matchBeginTime }} />;
};